import { PageType } from '../../shared/enums/pageType';

export enum TrackingPageTypes {
    Homepage = 'Homepage',
}

export const trackingTypeByPage = {
    [PageType.Home]: TrackingPageTypes.Homepage,
};
